import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CMSINFO_LINK } from "../../actions/types";
// 学院动态的列表
class CmsSectionList extends Component {
  render() {
    return (
      <div className="cms-section-list">
        <div className="title">{this.props.sectionListTitle}</div>
        {this.renderCmsListItem()}
      </div>
    );
  }
  renderCmsListItem() {
    if (this.props.datas) {
      return this.props.datas.map(data => {
        const { pubDate, addtime, title, link, url } = data;
        return (
          <Link
            key={link || url}
            className="cms-section-list-item"
            to={{
              pathname: `${CMSINFO_LINK}=${link || url}`,
              state: { data }
            }}
          >
            <span className="item-title">{title}</span>
            <span className="date">{pubDate || addtime}</span>
          </Link>
        );
      });
    } else {
      return <div />;
    }
  }
}
export default CmsSectionList;
